import React from "react";
import { Typography } from "@mui/material";

import MinimalLayoutWrapper from '../components/shared/MinimalLayoutWrapper';

const NotFound = () => {

    return (
        <MinimalLayoutWrapper>
            <Typography component="h1" variant="h4" sx={{ m: 0 }}>
                404
            </Typography>
            <Typography component="h1" variant="body2" sx={{ m: 0 }}>
                Page not found
            </Typography>
        </MinimalLayoutWrapper>
    );
};

export default NotFound;
